const MILLION = 1000000;

export {
  MILLION,
};
